/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type UserProgressionStatus =
  (typeof UserProgressionStatus)[keyof typeof UserProgressionStatus];

export const UserProgressionStatus = {
  in_progress: "in_progress",
  completed: "completed",
  abandoned: "abandoned",
} as const;
